/*
 * Public API Surface of kraken-masthead
 */

export * from './lib/kraken-masthead.service';
export * from './lib/kraken-masthead.component';
export * from './lib/kraken-masthead.module';
